import { render, staticRenderFns } from "./first_new.vue?vue&type=template&id=cf1027a8&scoped=true"
import script from "./first_new.vue?vue&type=script&lang=js"
export * from "./first_new.vue?vue&type=script&lang=js"
import style0 from "./first_new.vue?vue&type=style&index=0&id=cf1027a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1027a8",
  null
  
)

export default component.exports